import { AxiosResponse } from "axios";
import { CorrecaoContabil } from "../../../../Models/Domain/Viagem/Financeiro/CorrecaoContabil";
import RequestUtilitario, { MutationBasicaParam, QueryBasicaParam } from "../../../../Utils/RequisicaoUtilitario";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Axios } from "../../../Axios";
import { queryClient } from "../../../../App";
export function useCorrecaoContabilSalvar({
    onSuccess,
    ...rest
}:MutationBasicaParam<CorrecaoContabil, AxiosResponse<void>>) {
    return useMutation({
        ...rest,
        mutationFn : (dataRequest) => {
            if (!(dataRequest.codPlanoContas > 0))
                dataRequest.codPlanoContas = dataRequest.planoContas?.codigo ?? 0;
            
            return dataRequest.codigo > 0
                ? Axios.put(`viagem/financeiro/CorrecaoContabil/${dataRequest.codigo}`, dataRequest)
                : Axios.post(`viagem/financeiro/CorrecaoContabil`, dataRequest)
            ;
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Viagem.Financeiro.CorrecaoContabil.Listar"] });
            onSuccess?.(retorno, entrada, context);
        }
    });
}
export function useCorrecaoContabilDesativar({
    onSuccess,
    ...rest
}:MutationBasicaParam<CorrecaoContabil, AxiosResponse<void>>) {
    return useMutation({
        ...rest,
        mutationFn : (dataRequest) => {            
            return Axios.delete(`viagem/financeiro/CorrecaoContabil/${dataRequest.codigo}`);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Viagem.Financeiro.CorrecaoContabil.Listar"] });
            queryClient.invalidateQueries({ queryKey: [`Viagem.Financeiro.CorrecaoContabil.Buscar.${entrada.codigo}` ]});
            onSuccess?.(retorno, entrada, context);
        }
    });
}

export function useCorrecaoContabilListar({
    correcaoContabil,
    ativo,
    ...rest
}:QueryBasicaParam<AxiosResponse<CorrecaoContabil[]>, CorrecaoContabil[], {
    correcaoContabil?:CorrecaoContabil,
    ativo?:boolean,
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...(correcaoContabil ?? {}),
        ativo
    });

    return useQuery({
        ...rest,
        queryKey : [ "Viagem.Financeiro.CorrecaoContabil.Listar", `Viagem.Financeiro.CorrecaoContabil.Listar?${queryString}` ],
        queryFn : () => Axios.get<CorrecaoContabil[]>(`viagem/financeiro/CorrecaoContabil?${queryString}`),
        select(data) {
            return data.data.map(m => {
                m.dataCriacao = new Date(m.dataCriacao as any);
                m.dataPagamento = new Date(m.dataPagamento as any);
                return m;
            })
        },
    });
}

export function useCorrecaoContabilListarPorViagem({
    codViagem,
    correcaoContabil,
    ...rest
}:QueryBasicaParam<AxiosResponse<CorrecaoContabil[]>, CorrecaoContabil[], {
    codViagem:number;
    correcaoContabil?:CorrecaoContabil
}>) {
    const queryString = RequestUtilitario.objectToQueryString(correcaoContabil ?? {});

    return useQuery({
        ...rest,
        queryKey : [ "Viagem.Financeiro.CorrecaoContabil.Listar", `Viagem.Financeiro.CorrecaoContabil.ListarPorViagem.${codViagem}?${queryString}` ],
        queryFn : () => Axios.get<CorrecaoContabil[]>(`viagem/financeiro/CorrecaoContabil/viagem/${codViagem}?${queryString}`),
        select(data) {
            return data.data.map(m => {
                m.dataCriacao = new Date(m.dataCriacao as any);
                m.dataPagamento = new Date(m.dataPagamento as any);
                return m;
            })
        },
    });
}


export function useCorrecaoContabilBuscar({
    codigo,
    ...rest
}:QueryBasicaParam<AxiosResponse<CorrecaoContabil|null>, CorrecaoContabil|null, {
    codigo:number;
}>) {
    return useQuery({
        ...rest,
        queryKey : [ "Viagem.Financeiro.CorrecaoContabil.Listar", `Viagem.Financeiro.CorrecaoContabil.Buscar.${codigo}` ],
        queryFn : () => Axios.get<CorrecaoContabil>(`viagem/financeiro/CorrecaoContabil/${codigo}`),
        select(data) {
            if (data.data == null) return null;
            
            data.data.dataCriacao = new Date(data.data.dataCriacao as any);
            data.data.dataPagamento = new Date(data.data.dataPagamento as any);
            return data.data;
        },
    });
}

export default {
    useCorrecaoContabilSalvar,
    useCorrecaoContabilListar,
    useCorrecaoContabilListarPorViagem,
    useCorrecaoContabilBuscar
}